import { useIonModal as t } from "@ionic/react";
const M = (o) => {
  const {
    component: s,
    modalOptions: n
  } = o, [e, l] = t(s);
  return {
    openModal: () => e(n),
    closeModal: () => l()
  };
};
export {
  M as useModal
};
